import React, { useCallback, useState } from "react";
import { Form, Input, message, Modal, Select as AntSelect } from "antd";
import Props from "./Props";
import { generate, generateByKey } from "../../../../helpers/hash";
import { Option } from "../Interfaces";

const NEW_ITEM = "NEW_ITEM";

const UNIQUE_ID = generate();

const SelectWithNewItem: React.FC<Props> = ({ name, config, ...rest }) => {
  const [visible, setVisibility] = useState(false);
  const [value, setValue] = useState<string>("");
  const [options, setOptions] = useState<Option[]>(config.options || []);
  const [newOption, setNewOption] = useState<string>("");

  const onChangeSelectHandler = useCallback((optionValue) => {
    if (optionValue !== NEW_ITEM) {
      setValue(optionValue);
      return;
    }

    setVisibility(true);
  }, []);

  const onChangeNewOptionHandler = useCallback((event) => {
    setNewOption(event.target.value);
  }, []);

  const onSubmitNewOption = useCallback(() => {
    if (newOption.trim().length <= 0) {
      message.error("New option is required!");
      return;
    }

    setOptions([
      ...options,
      {
        title: newOption,
        value: newOption,
      },
    ]);

    setNewOption("");
    setVisibility(false);
    setValue(newOption);
  }, [newOption, options]);

  const onCancelNewOption = useCallback(() => {
    setNewOption("");
    setVisibility(false);
    setValue("");
  }, []);

  return (
    <div>
      <Form.Item
        name={name}
        label={config.label}
        rules={config.validationRules}
        labelCol={{ span: 24 }}
        valuePropName={value || undefined}
        {...rest}
      >
        <AntSelect
          placeholder={config.placeholder}
          showSearch={config.showSearch}
          onChange={onChangeSelectHandler}
          value={value || undefined}
          getPopupContainer={(triggerNode) => triggerNode.parentNode}
        >
          <AntSelect.Option value="" disabled>
            Select Option
          </AntSelect.Option>
          {options.map((option, index) => {
            return (
              <AntSelect.Option
                value={option.value}
                key={generateByKey(index.toString(), UNIQUE_ID)}
              >
                {option.title}
              </AntSelect.Option>
            );
          })}
          <AntSelect.Option value={NEW_ITEM}>+ New Item</AntSelect.Option>
        </AntSelect>
      </Form.Item>
      <Modal
        visible={visible}
        onOk={onSubmitNewOption}
        onCancel={onCancelNewOption}
      >
        <div className="ant-form-item-label">
          <label htmlFor="new-option">New Option</label>
        </div>
        <Input
          id="new-option"
          type="text"
          value={newOption}
          onChange={onChangeNewOptionHandler}
        />
      </Modal>
    </div>
  );
};

export default SelectWithNewItem;
